const raw = process.env.NEXT_PUBLIC_AMPLITUDE_FLAG_OVERRIDES ?? '';
const params = new URLSearchParams(raw);

const overrides = new Map<string, string>();
for (const [key, value] of params) {
  overrides.set(key, value || 'on');
}

export const LOCAL_OVERRIDES = overrides;
